import { Box, Divider, Typography } from '@mui/material'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { renderLawsuitsPerson } from '../../../components/utilities/MapLawsuits'
import { RenderNegativeMedia } from '../../../components/utilities/MapNegativeMedia'
import RecursiveProperty from '../../../components/utilities/RenderJSON'
import { renderCertificates } from '../../../components/utilities/MapCertificates'
import SanctionsSummary from './KybSanctionsSummary/SanctionsSummary'
import LawsuitsBusinessCheck from './LawsuitsBusinessCheck'
import LawsuitsOwnersCheck from './LawsuitsOwnersCheck'
import LawsuitsPersonCheck from './LawsuitsPersonCheck'
import AmlddCheckDetail from './AmlddCheckDetail'
import { KybUtils } from '../kyb.utils'

const KybCheckDetail = ({ name, value, type }) => {
  const { t } = useTranslation(['common', 'messages'])
  const { theme } = useSelector((state) => state.theme)


  if (
    value?.type === 'SERASA_SCORE' &&
    value?.found === false &&
    value?.checkDetails?.razao === null
  ) {
    return (
      <Box className="recursive-property" sx={{ backgroundColor: theme === 'light' ? '#FCFFFD' : '#020D06', p: 2 }}>
        <Typography>
          <strong>{t('common:information')}:</strong>
          {t('messages:providerOffline')}
        </Typography>
      </Box>
    )
  }

  if (name === 'jap') {
    const checkDetails = Array.isArray(value?.checkDetails) ? value?.checkDetails[0]?.Lawsuits : value?.checkDetails

    // If no checkDetails at all, show no data message
    if (!checkDetails) {
      return (
        <Box className="accordion-jap" sx={{ backgroundColor: theme === 'light' ? '#FCFFFD' : '#020D06', p: 2 }}>
          <Typography>{t('common:noDataAvailable')}</Typography>
        </Box>
      )
    }

    const notFound = value?.found === false || 'informação' in checkDetails

    if (notFound) {
      return (
        <Box className="accordion-jap" sx={{ backgroundColor: theme === 'light' ? '#FCFFFD' : '#020D06' }}>
          <RecursiveProperty property={checkDetails} excludeBottomBorder={false} rootProperty={true} />
        </Box>
      )
    }

    return <LawsuitsBusinessCheck data={checkDetails} theme={theme} />
  }

  if (name === 'jap_jus') {
    const checkDetails = Array.isArray(value?.checkDetails) ? value?.checkDetails[0]?.Lawsuits : value?.checkDetails

    // If no checkDetails at all, show no data message
    if (!checkDetails) {
      return (
        <Box className="accordion-jap" sx={{ backgroundColor: theme === 'light' ? '#FCFFFD' : '#020D06', p: 2 }}>
          <Typography>{t('common:noDataAvailable')}</Typography>
        </Box>
      )
    }

    const notFound = value?.found === false || 'informação' in checkDetails

    if (notFound) {
      return (
        <Box className="accordion-jap" sx={{ backgroundColor: theme === 'light' ? '#FCFFFD' : '#020D06' }}>
          <RecursiveProperty property={checkDetails} excludeBottomBorder={false} rootProperty={true} />
        </Box>
      )
    }

    return type === 'PERSON'
      ? <LawsuitsPersonCheck data={checkDetails} theme={theme} />
      : <LawsuitsBusinessCheck data={checkDetails} theme={theme} />
  }

  if (name === 'lawsuitsPerson') {
    const checkDetails = Array.isArray(value?.checkDetails) ? value?.checkDetails[0]?.Lawsuits : value?.checkDetails

    // If no checkDetails at all, show no data message
    if (!checkDetails) {
      return (
        <Box className="accordion-jap" sx={{ backgroundColor: theme === 'light' ? '#FCFFFD' : '#020D06', p: 2 }}>
          <Typography>{t('common:noDataAvailable')}</Typography>
        </Box>
      )
    }

    const notFound = value?.found === false || 'informação' in checkDetails

    if (notFound) {
      return (
        <Box className="accordion-jap" sx={{ backgroundColor: theme === 'light' ? '#FCFFFD' : '#020D06' }}>
          <RecursiveProperty property={checkDetails} excludeBottomBorder={false} rootProperty={true} />
        </Box>
      )
    }

    return <LawsuitsPersonCheck data={checkDetails} theme={theme} />
  }

  if (name === 'lawsuits') {
    const checkDetails = Array.isArray(value?.checkDetails)
      ? value?.checkDetails[0]?.OwnersLawsuits
      : value?.checkDetails

    // If no checkDetails at all, show no data message
    if (!checkDetails) {
      return (
        <Box className="accordion-jap" sx={{ backgroundColor: theme === 'light' ? '#FCFFFD' : '#020D06', p: 2 }}>
          <Typography>{t('common:noDataAvailable')}</Typography>
        </Box>
      )
    }

    const notFound = value?.found === false || 'informação' in checkDetails

    if (notFound) {
      return (
        <Box className="accordion-jap" sx={{ backgroundColor: theme === 'light' ? '#FCFFFD' : '#020D06' }}>
          <RecursiveProperty property={checkDetails} excludeBottomBorder={false} rootProperty={true} />
        </Box>
      )
    }

    return <LawsuitsOwnersCheck data={checkDetails} theme={theme} />
  }

  if (name === 'lawsuitsPerson') {
    return <Box>{renderLawsuitsPerson(value?.checkDetails, theme)}</Box>
  }

  if (name === 'negativeMedia') {
    return (
      <Box>
        <h3>{t('common:kyb.checks.negativeMedia.source1.title')}</h3>
        <Box>{RenderNegativeMedia(value?.checkDetails?.source1, theme)}</Box>
        <br />
        {value?.checkDetails?.source2 && <h3>{t('common:kyb.checks.negativeMedia.source2.title')}</h3>}
        {value?.checkDetails?.source2 && (
          <Box className="accordion-jap" sx={{ backgroundColor: theme === 'light' ? '#FCFFFD' : '#020D06' }}>
            <RecursiveProperty
              property={value?.checkDetails?.source2}
              excludeBottomBorder={false}
              rootProperty={true}
            />
          </Box>
        )}
      </Box>
    )
  }

  if (name === 'cnjJuridico' || name === 'cnjFisico' || name === 'antecedentesPf') {
    return renderCertificates(Array.isArray(value?.checkDetails) ? value.checkDetails[0] : value.checkDetails[0], theme)
  }

  if (name === 'kyc') {
    return (
      <Box>
        <SanctionsSummary checkDetails={value?.checkDetails} type={type} />
        <Divider sx={{ margin: '.5rem 0' }} />
        <RecursiveProperty
          property={Array.isArray(value?.checkDetails) ? value?.checkDetails[0] : value?.checkDetails}
          excludeBottomBorder={false}
          rootProperty={true}
        />
      </Box>
    )
  }

  // AMLDD checks
  if (KybUtils.isAmlddCheck(name)) {
    const checkTypeMap = {
      amlddEsg: 'AMLDD_ESG',
      amlddLri: 'AMLDD_LRI',
      amlddPep: 'AMLDD_PEP',
      amlddMtlsn: 'AMLDD_MTLSN',
      amlddMtlsnSimple: 'AMLDD_MTLSN_SIMPLE',
      amlddMtlsnWithNews: 'AMLDD_MTLSN_WITH_NEWS'
    }
    return (
      <AmlddCheckDetail
        checkType={checkTypeMap[name]}
        checkDetails={value?.checkDetails}
        theme={theme}
      />
    )
  }

  return (
    <Box className="recursive-property" sx={{ backgroundColor: theme === 'light' ? '#FCFFFD' : '#020D06' }}>
      <RecursiveProperty
        property={Array.isArray(value?.checkDetails) ? value?.checkDetails[0] : value?.checkDetails}
        excludeBottomBorder={false}
        rootProperty={true}
      />
    </Box>
  )
}

export default KybCheckDetail
